import { useState } from "react";

const useCircleHandler = (idToken) => {
  const [loading, setLoading] = useState(false);
  const [followedUsers, setFollowedUsers] = useState(null);
  const [usersRecommended, setUsersRecommended] = useState(null);

  const loadCircle = async () => {
    setLoading(true);
    try {
      await Promise.all([fetchFollowedUsers(), fetchUsersRecommended()]);
    } catch (error) {
      console.error("Error loading circle data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsersRecommended = async () => {
    setUsersRecommended([
      { first_name: 'Eliana', last_name: "Gicodi", email: 'eliana.gicodi@gmail.com', extra_content: 'Cinefila', is_critic: true },
      { first_name: 'Javier', last_name: "Ponzo", email: 'javiponzo@icloud.com', extra_content: '@JaviPonzo', is_critic: true },
      { first_name: 'Matias', last_name: "Rampoldi", email: 'matirampoldi@gmail.com', extra_content: '@rampoldimati', is_critic: true }
    ]);
  };

  const fetchFollowedUsers = async () => {
    try {
      const response = await fetch(`https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=getfollowedusers&id_token=${idToken}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      if (data.status !== 'success') {
        throw new Error('Api error');
      }
      setFollowedUsers(data.content.length ? data.content : []);
    } catch (error) {
      console.error('Error fetching followed users:', error);
      setFollowedUsers([]);
    }
  };

  const followUser = async (userTofollowEmail) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=followuser`,
        {
          method: "POST",
          body: JSON.stringify({
            id_token: idToken,
            user_to_follow_email: userTofollowEmail
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      if (data.status === "error") {
        throw new Error("API error");
      }
      if (data.status === "not_found") {
        setLoading(false);
        return;
      }
      const newFollowedUser = data.content;
      setFollowedUsers([...followedUsers, newFollowedUser])
      setLoading(false);
      return newFollowedUser;
    } catch (error) {
      console.error("Error following user:", error);
      setLoading(false);
      throw error;
    }
  };

  const unfollowUser = async (userToUnfollowEmail) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=unfollowuser`,
        {
          method: "POST",
          body: JSON.stringify({
            id_token: idToken,
            user_to_unfolllow_email: userToUnfollowEmail
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      if (data.status !== "success") {
        throw new Error("API error");
      }
      setFollowedUsers(followedUsers.filter(user => user.email !== userToUnfollowEmail));
      setLoading(false);
      return true;
    } catch (error) {
      console.error("Error unfollowing user:", error);
      setLoading(false);
      return false;
    }
  };

  return [loading, followedUsers, usersRecommended, followUser, unfollowUser, loadCircle];
};

export default useCircleHandler;
